import { createContext } from "react";

export interface TenantIdentity {
  tenantKey: Key;
  makerFeaturesEnabled: boolean;
}

export const TenantContext = createContext<TenantIdentity | null>(null);